<section
  class="upload-full-zone"
  [class.upload-full-zone--active]="dragActive"
  (dragenter)="onDragEnter($event)"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onFileDrop($event)"
  (dragend)="onDragEnd($event)">
  <input
    type="file"
    #fileInput
    class="file-input"
    [accept]="accept"
    [multiple]="multiple"
    (change)="onFileInputChange($event)" />
  <div class="dropzone-full">
    <div class="dropzone-icon"></div>
    <div class="dropzone-title">{{ dragLabelKey | translate }}</div>
    <div class="dropzone-subtitle">{{ hintLabelKey | translate }}</div>
    <app-button
      class="dropzone-button"
      (onClick)="triggerFileSelect($event)"
      (click)="$event.stopPropagation()">
      {{ buttonLabelKey | translate }}
    </app-button>
    <div
      class="dropzone-limit"
      *ngIf="multiple">
      {{ limitLabelKey | translate }}
    </div>
  </div>
</section>
